import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Company Management Services
 * !== 업체 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/co`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co`,
    api_coCd: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co-cd`,
    comApi: `${process.env.REACT_APP_API_PTLI}/api/v1/ptl/comn/comn/cocd`,
    infAPi: `${process.env.REACT_APP_API_LCMI}/api/v1/lcmi/comn`,
    nodes: [],
};

export const URLS = {
    ptli0905001q: `${BASE.path}/ptli0905001q`, // Company Management List !==  업체 관리 목록 ==!
    ptli0905002s: `${BASE.path}/ptli0905002s`, // Company Registration !== 업체 등록 ==!
    ptli0905003s: `${BASE.path}/ptli0905003s`, // Company Modification !== 업체 수정 ==!
    ptli0905004q: `${BASE.path}/ptli0905004q`, // Company Details !== 업체 상세 ==!
    ptli0905005s: `${BASE.path}/ptli0905005s`, // Company Code Registration !== 업체 코드 등록 ==!
};

export const PGEUIDS = {
    ptli0905004q: "ptli0905004q",
};

export const APIS = {
    // TIN Number Search !== TIN 번호 조회 ==!
    getPayerTinNoLst: (tinNo: any, bizYn: any) =>
        comnUtils.getCode({ area: "payerTinNo", keyword: tinNo, param2: bizYn }),

    // Check Company Approval List !==  업체 승인 요청 목록 조회 ==!
    getCoList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),

    // Create User !== 사용자 생성 ==!
    createUsr: (data: any) => api.post(`${BASE.api}`, { ...data }),

    // Update Company And Representative Information !==  업체 및 대표자 정보 저장 ==!
    updateCoAndRppnInfo: (data: any) => api.put(`${BASE.api}`, { ...data }),

    // Company Information details inquiry !== 업체 정보 조회 ==!
    getCoInfoMgmt: (coTin: any) => api.get(`${BASE.api}/${coTin}`),

    // Create Company Code !== 업체 코드 생성 ==!
    createCoCd: (data: any) => api.post(`${BASE.api_coCd}`, { ...data }),

    // Update Company Code !==  업체 코드 수정 ==!
    updateCoCd: (data: any) => api.put(`${BASE.api_coCd}`, { ...data }),

    // Delete Company Code !== 업체 코드 삭제 ==!
    deleteCoCd: (coTin: any, coSn: any) => api.delete(`${BASE.api_coCd}/${coTin}/${coSn}`),

    // Create Company Employee User. !== 업체 직원 사용자를 생성 한다. ==!
    createCoEmpUsr: (data: any) => api.post(`${BASE.api}/coEmp`, { ...data }),

    // Modify Company Employee User. !==  업체 직원 사용자를 수정 ==!
    updateCoEmpUsr: (data: any) => api.put(`${BASE.api}/coEmp`, { ...data }),

    // Delete Company Employee !== 업체 직원 사용자 삭제 ==!
    deleteEmp: (data: any) => api.delete(`${BASE.api}/coEmp`, { params: comnUtils.toGetParams({ ...data }) }),

    // Company Declarant Registration !== 업체 신고인 저장 ==!
    saveCoDclt: (data: any) => api.post(`${BASE.api}/dclt`, { ...data }),

    // TIN Number Search !== TIN 번호 조회 ==!
    getCoDcltDtl: (data: any) => api.get(`${BASE.comApi}/dclt`, { params: comnUtils.toGetParams({ ...data }) }),

    // TIN Number Search !== TIN 번호 조회 ==!
    getCoDcltList: (coTin: any) => api.get(`${BASE.comApi}/dclt/list?coTin=${coTin}`),

    // Company Declarant Modify !== 업체 신고인 저장 ==!
    updateCoDclt: (data: any) => api.put(`${BASE.api}/dclt`, { ...data }),

    // Company Declarant Delete !== 업체 신고인 삭제 ==!
    deleteCoDclt: (data: any) => api.delete(`${BASE.api}/dclt`, { params: comnUtils.toGetParams(data) }),

    // Reset the business user password. !== 업체 사용자 비밀번호를 초기화한다. ==!
    updateCoUsrPwdInit: (data: any) => api.put(`${BASE.api}/pwd-init`, { ...data }),

    // Select. Licensing Applicable Company Code List !== 라이센스 해당하는 업체코드 목록조회 ==!
    getLcneIssCoTpList: (coTin: string) =>
        api.get(`${process.env.REACT_APP_API_PTLI}/api/v1/ptl/comn/comn/cocd/lcneIssCoTpList?coTin=${coTin}`),

    // Company User duplicate check !== 업체사용자 중복 체크 ==!
    getCoDuplCheck: (xtrnUsrIdntfNo: any) =>
        api.get(`${BASE.api}/getCoDuplCheck`, { params: comnUtils.toGetParams({ xtrnUsrIdntfNo: xtrnUsrIdntfNo }) }),

    // Employee Business Code List !== 업체사용자 중복 체크 ==!
    getEmpUsrCocdList: ({ coTin, xtrnUsrUuid }: any) =>
        api.get(`${process.env.REACT_APP_API_PTLI}/api/v1/ptl/comn/comn/usr/cocd/${coTin}/${xtrnUsrUuid}`),

    getLcmWrhsCoTpMap: (coTin: any) => api.get(`${BASE.api}/lcm-wrhs-cotp-map?coTin=${coTin}`),

    // EPZ License Permission Information Search !== EPZ 면허 허가 정보  ==!
    getEpzLcnePrmssInfo: (coTin: any) => api.get(`${BASE.api}/epz-lcne-prmss?coTin=${coTin}`),

    // Get a excel list of Company Management. !== 업체체 관리 엑셀 목록을 조회한다. ==!
    getCoExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),

    getExternalUserReport: (coTin: string) => {
        return api.get(`${BASE.api}/rprt/${coTin}`, {
            responseType: "arraybuffer",
        });
    },

    // Check TASAC CFA Certificate Information (IF-E-LCM-003) !== ICD, CFS 증명서 정보 확인 ==!
    chkWrhsCertificate: (data: any) => {
        return api.get(`${BASE.infAPi}/chkCertificate/wrhs`, {
            params: {
                ...comnUtils.toGetParams(data),
            },
        });
    },

    getCoTinCntyCheck: (coTin: any) => {
        return api.get(`${BASE.api}/getCoTinCntyCheck`, {
            params: comnUtils.toGetParams({ coTin: coTin }),
        });
    },

    // Change the company name to the name stored in TAXPAYER. !== 업체명을 TAXPAYER 저장 된 업체명으로 변경한다. ==!
    updateCoNm: (data: any) => {
        return api.put(`${BASE.api}/co-nm`, {
            ...data,
        });
    },

};

/*
    Excluding Company Type !== 제외 업체 유형 ==!
    - 제외 : "BK","BT","CT","ED","SC","TT"
    - OGA유형 제외 : "AE","FC","FS","GC","GD","MA","SB","TB","TC","TD","TF","TI","ZB","ZF","ZR"
*/
export const CO_CD_EXCL_SET: string[] = [
    "BK",
    "BT",
    "CT",
    "ED",
    "SC",
    "TT",
    "AE",
    "FC",
    "FS",
    "GC",
    "GD",
    "MA",
    "SB",
    "TB",
    "TC",
    "TD",
    "TF",
    "TI",
    "ZB",
    "ZF",
    "ZR",
];

export const SF_CO_SRCH: TFormSchema = {
    id: "form_coAprvSrch",
    schema: {
        coTin: { type: "text", label: "L_CO_TIN" },
        coNm: { type: "text", label: "L_CO_NM", maxLength: 100 },
        usrNm: { type: "text", label: "L_RPPN_NM", maxLength: 100 },
        empTin: { type: "text", label: "L_CO_EMP_TIN" },
    },
};

export const SG_CO_LIST: TGridSchema = {
    id: "grid_coAprvList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN_TP", binding: "tinTp", width: "10%" }] },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "10%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_RPPN_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_TIN_STAT", binding: "tinStat", width: "10%" }] },
    ],
    body: [
        {
            cells: [{ binding: "tinTp" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "tinStat" }],
        },
    ],
};
//
export const SG_CO_MGMT_EXCEL_LIST: TGridSchema = {
    id: "grid_coExcelList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN_TP", binding: "tinTp", width: "10%" }] },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "10%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_RPPN_NM", binding: "rppnNm", width: "*" }] },
        { cells: [{ header: "L_TIN_STAT", binding: "tinStat", width: "10%" }] },
        { cells: [{ header: "L_CO_CD", binding: "coCd", width: 300 }] },
        { cells: [{ header: "L_CO_TP_CD", binding: "coTpCd", width: 300 }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: "*" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 50 }] },
        { cells: [{ header: "L_RPPN_YN", binding: "coRppnYn", width: "*" }] },
        { cells: [{ header: "L_TIN_NO", binding: "xtrnUsrIdntfNo", width: "*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "*" }] },
        { cells: [{ header: "L_DEL_YN", binding: "delYn", width: 70 }] },
    ],
    body: [
        { cells: [{ binding: "tinTp" }] },
        { cells: [{ binding: "coTin" }] },
        { cells: [{ binding: "coNm", align: "left" }] },
        { cells: [{ binding: "rppnNm", align: "left" }] },
        { cells: [{ binding: "tinStat" }] },
        { cells: [{ binding: "coCd" }] },
        { cells: [{ binding: "coTpCd" }] },
        { cells: [{ binding: "cstmOfceCd", type: "text", area: "cstmCd" }] },
        { cells: [{ binding: "useYn" }] },
        { cells: [{ binding: "coRppnYn", type: "text", align: "center" }] },
        { cells: [{ binding: "xtrnUsrIdntfNo", type: "text", align: "left" }] },
        { cells: [{ binding: "usrNm", type: "text", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm", type: "text", align: "center" }] },
        { cells: [{ binding: "delYn", type: "text", align: "center" }] },
    ],
};

export const SF_USR_APLY_INFO: TFormSchema = {
    id: "form_usrAplyInfo",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_TIN_NO", required: true },
        usrNm: { type: "text", label: "L_USR_NM", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
            required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", controlSize: 10, required: true },
        usrPwd: { type: "password", label: "L_USR_PWD", required: true },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM", required: true },
        aprvYn: { type: "text", label: "L_APRV_YN" },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        preXtrnUsrAplyId: { type: "text", label: "L_PRE_XTRN_USR_APLY_ID" },

        coAplyId: { type: "text", label: "L_CO_APLY_ID" },
        coTin: { type: "text", label: "L_CO_TIN", required: true },
        coNm: { type: "text", label: "L_CO_NM", required: true, readOnly: true },
        inwdCoYn: {
            type: "radio",
            label: "L_INWD_CO_YN",
            options: [
                { label: "Domestic Company", value: "Y" },
                { label: "Foreign Company", value: "N" },
            ],
            defaultValue: "Y",
            required: true,
        },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
            required: true,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10 },
        tinStat: {
            type: "radio",
            label: "L_TIN_STAT",
            options: [
                { label: "Active", value: "Active" },
                { label: "In Active", value: "In Active" },
            ],
        },
        taxpayerCoNm: { type: "text", label: "L_CO_NM", required: true },
    },
};

export const SF_CO_TP_INFO: TFormSchema = {
    id: "form_coTpInfo",
    schema: {
        coTpArray: {
            type: "array",
            schema: {
                coTin: { label: "L_CO_TIN", type: "text" },
                coSn: { label: "L_CO_SN", type: "text" },
                coTpCd: {
                    label: "L_CO_TP_CD",
                    type: "select",
                    all: false,
                    area: "comnCd",
                    comnCd: "COM0011",
                    required: true,
                    editType: "both",
                },
                coCdRo: { label: "L_CO_CD", type: "text", placeholder: "automatically generated", readOnly: true },
                coCdSelect: { label: "L_CO_CD", type: "select", required: true },
                coCd: { label: "L_CO_CD", type: "text", placeholder: "Direct input", required: true },
                coTpNm: { label: "L_CO_CD_NM", type: "text", required: true, readOnly: true },
                cstmOfceCd: {
                    label: "L_CSTM_OFCE_CD",
                    type: "code",
                    area: "cstmCd",
                    popupSize: "md",
                    popupParams: {
                        // dclrYn: "Y",
                    },
                    required: true,
                },
                prcssStatCd: { label: "L_PRCSS_STAT_CD", type: "text" }, //본 테이블에만 존재
                statMdfyRsn: { label: "L_STAT_MDFY_RSN", type: "text" }, //본 테이블에만 존재
                gainCfrmOmsnYn: {
                    type: "select",
                    label: "L_GAIN_CFRM_OMSN_YN",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                },
                gaotCfrmOmsnYn: {
                    type: "select",
                    label: "L_GAOT_CFRM_OMSN_YN",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                },
                stckCretCtraTpCd: {
                    type: "select",
                    label: "L_STCK_CRET_CTRA_TP_CD",

                    area: "comnCd",
                    comnCd: "CGM0095",
                },
                stckClarCtraTpCd: {
                    type: "select",
                    label: "L_STCK_CLAR_CTRA_TP_CD",
                    area: "comnCd",
                    comnCd: "CGM0096",
                },
                autoCriYn: {
                    type: "select",
                    label: "L_AUTO_CRI_YN",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                },
                autoCroYn: {
                    type: "select",
                    label: "L_AUTO_CRO_YN",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                },
                wrhsDpstDays: { label: "L_WRHS_DPST_DAYS", type: "number" },
                psnWrhsYn: {
                    type: "select",
                    label: "L_PSN_WRHS_YN",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                },
                rskCagYn: {
                    type: "select",
                    label: "L_RSK_CAG_YN",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                },
                spcdlWrhsYn: {
                    type: "select",
                    label: "L_SPCDL_WRHS_YN",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                },
                bsopId: {
                    type: "file",
                    label: "L_ATCH_FILE",
                    edit: true,
                    bsopClsfCd: "PTL",
                    isPublic: true,
                },
                lcneUseTpCd: {
                    type: "select",
                    label: "L_LCNE_TP_CD",
                    area: "comnCd",
                    comnCd: "LCM0019",
                    required: true,
                },
            },
        },
    },
};

export const SF_CO_TP_DETAIL_INFO: TFormSchema = {
    id: "form_coTpInfo",
    schema: {
        coTin: { label: "L_CO_TIN", type: "text" },
        coSn: { label: "L_CO_SN", type: "text" },
        coTpCd: {
            label: "L_CO_TP_CD",
            type: "select",
            all: false,
            area: "comnCd",
            comnCd: "COM0011",
            excludes: ["I", "CU", ...CO_CD_EXCL_SET],
            editType: "both",
            required: true,
        },
        coCdRo: { label: "L_CO_CD", type: "text", placeholder: "automatically generated", readOnly: true },
        coCdSelect: { label: "L_CO_CD", type: "select", required: true },
        coCd: { label: "L_CO_CD", type: "text", placeholder: "Direct input" },
        coTpNm: { label: "L_CO_CD_NM", type: "text", required: true, readOnly: true },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                dclrYn: "Y",
            },
            required: true,
        },
        tasacCrtfNoStr: { label: "L_TASC_CRTF_NO", type: "text", placeholder: "Direct input" },
        tasacCrtfNo: {
            label: "L_TASC_CRTF_NO",
            type: "text",
            placeholder: "Direct input",
            required: true,
        },
        prcssStatCd: { label: "L_PRCSS_STAT_CD", type: "text" }, //본 테이블에만 존재
        statMdfyRsn: { label: "L_STAT_MDFY_RSN", type: "text" }, //본 테이블에만 존재
        gainCfrmOmsnYn: {
            type: "select",
            label: "L_GAIN_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        gaotCfrmOmsnYn: {
            type: "select",
            label: "L_GAOT_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        stckCretCtraTpCd: {
            type: "select",
            label: "L_STCK_CRET_CTRA_TP_CD",

            area: "comnCd",
            comnCd: "CGM0095",
        },
        stckClarCtraTpCd: {
            type: "select",
            label: "L_STCK_CLAR_CTRA_TP_CD",
            area: "comnCd",
            comnCd: "CGM0096",
        },
        autoCriYn: {
            type: "select",
            label: "L_AUTO_CRI_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        autoCroYn: {
            type: "select",
            label: "L_AUTO_CRO_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        wrhsDpstDays: { label: "L_WRHS_DPST_DAYS", type: "number" },
        psnWrhsYn: {
            type: "select",
            label: "L_PSN_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        spcdlWrhsYn: {
            type: "select",
            label: "L_SPCDL_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        rskCagYn: {
            type: "select",
            label: "L_RSK_CAG_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        bsopId: {
            type: "file",
            label: "L_ATCH_FILE",
            edit: true,
            bsopClsfCd: "PTL",
            isPublic: true,
        },
        lcneUseTpCd: {
            type: "select",
            label: "L_LCNE_TP_CD",
            area: "comnCd",
            comnCd: "LCM0019",
        },
    },
};
//
export const SG_CO_TP_APLY_LIST: TGridSchema = {
    id: "grid_coAprvList",
    options: { pagination: "in", index: true, height: "auto" },
    head: [
        { cells: [{ header: "L_CO_CD", binding: "coCd", width: 300 }] },
        { cells: [{ header: "L_CO_TP_CD", binding: "coTpCd", width: 300 }] },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: 300 }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: "*" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 50 }] },
        { cells: [{ header: "L_ISS_STAT", binding: "lcneStatCd", width: 150 }] },
    ],
    body: [
        { cells: [{ binding: "coCd" }] },
        { cells: [{ binding: "coTpCd" }] },
        { cells: [{ binding: "coTin" }] },
        { cells: [{ binding: "cstmOfceCd", type: "code", area: "cstmCd" }] },
        { cells: [{ binding: "useYn" }] },
        { cells: [{ binding: "lcneStatCd", type: "code", area: "comnCd", comnCd: "LCM0006" }] },
    ],
};
//
export const SG_CO_EMP_LIST: TGridSchema = {
    id: "grid_coEmpList",
    options: { pagination: "in", index: true, height: "auto" },
    head: [
        { cells: [{ header: "L_RPPN_YN", binding: "coRppnYn", width: "*" }] },
        { cells: [{ header: "L_TIN_NO", binding: "xtrnUsrIdntfNo", width: "*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "*" }] },
        { cells: [{ header: "L_DEL_YN", binding: "delYn", width: 70 }] },
        { cells: [{ header: "L_RESET_PWD", binding: "resetPwd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "coRppnYn", type: "text", align: "center" }] },
        { cells: [{ binding: "xtrnUsrIdntfNo", type: "text", align: "left" }] },
        { cells: [{ binding: "usrNm", type: "text", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm", type: "text", align: "center" }] },
        { cells: [{ binding: "delYn", type: "text", align: "center" }] },
        { cells: [{ binding: "resetPwd", type: "text", align: "center" }] },
    ],
};

export const SF_CO_EMP_INFO: TFormSchema = {
    id: "form_coEmpInfo",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_TIN_NO", required: true },
        usrNm: { type: "text", label: "L_USR_NM", required: true },
        usrStatCd: {
            type: "select",
            label: "L_USR_STAT_CD",
            area: "comnCd",
            comnCd: "PTL0001",
        },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", required: true },
        usrPwd: { type: "password", label: "L_USR_PWD", required: true },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM", required: true },
        aprvYn: { type: "text", label: "L_APRV_YN" },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        coAplyId: { type: "text", label: "L_CO_APLY_ID" },
        coTin: { type: "text", label: "L_CO_TIN", required: true },
        coNm: { type: "text", label: "L_CO_NM", edit: false, readOnly: true },
        inwdCoYn: {
            type: "radio",
            label: "L_INWD_CO_YN",
            options: [
                { label: "Domestic Company", value: "Y" },
                { label: "Foreign Company", value: "N" },
            ],
            defaultValue: "Y",
            edit: false,
        },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO", edit: false },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO", edit: false },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
            edit: false,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10, edit: false },
        coRppnYn: {
            type: "select",
            label: "L_CO_RPPN_YN",
            options: [
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
            ],
            required: true,
        },
        cstmOfceCd: { type: "code", area: "cstmCd", label: "L_CSTM_OFCE_CD", edit: false },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000 },
        mdfyRsnFile: { type: "file", label: "L_ATCH_FILE", edit: true, controlSize: 10 },
    },
};

export const SF_CO_HIST_INFO: TFormSchema = {
    id: "form_coHistInfo",
    schema: {
        coTin: { type: "text", label: "L_CO_TIN" },
        histDtm: { type: "text", label: "L_HIST_DTM" },
        coNm: { type: "text", label: "L_CO_NM", readOnly: true },
        inwdCoYn: {
            type: "radio",
            label: "L_INWD_CO_YN",
            options: [
                { label: "Domestic Company", value: "Y" },
                { label: "Foreign Company", value: "N" },
            ],
            defaultValue: "Y",
        },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10 },
        coAplyId: { type: "text", label: "L_CO_APLY_ID" },
    },
};

export const SG_CO_HIST_LIST: TGridSchema = {
    id: "grid_coHistList",
    options: { pagination: "in", index: true, height: "auto" },
    head: [
        { cells: [{ header: "L_HIST_DTM", binding: "histDtm", width: "*" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_RPRS_TELNO", binding: "rprsTelno", width: "*" }] },
        { cells: [{ header: "L_CO_ADDR", binding: "coAddr", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "histDtm", type: "text", align: "center" }] },
        { cells: [{ binding: "coNm", type: "text", align: "left" }] },
        { cells: [{ binding: "rprsTelno", type: "text", align: "left" }] },
        { cells: [{ binding: "coAddr", type: "text", align: "left" }] },
    ],
};

export const SF_CO_CD_INFO: TFormSchema = {
    id: "form_coCdInfo",
    schema: {
        coTin: {
            type: "code",
            label: "L_CO_TIN",
            area: "coCd",
            popupSize: "md",
            required: true,
        },
        coSn: { label: "L_CO_SN", type: "text" },
        coTpCd: {
            label: "L_CO_TP_CD",
            type: "select",
            all: false,
            area: "comnCd",
            comnCd: "COM0011",
            required: true,
        },
        coCdRo: { label: "L_CO_CD", type: "text", placeholder: "automatically generated", readOnly: true },
        coCd: { label: "L_CO_CD", type: "text", placeholder: "Direct input", required: true },
        coTpNm: { label: "L_CO_CD_NM", type: "text", required: true },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                dclrYn: "Y",
            },
            required: true,
        },
        prcssStatCd: { label: "L_PRCSS_STAT_CD", type: "text" }, //본 테이블에만 존재
        statMdfyRsn: { label: "L_STAT_MDFY_RSN", type: "text" }, //본 테이블에만 존재
        gainCfrmOmsnYn: {
            type: "select",
            label: "L_GAIN_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        gaotCfrmOmsnYn: {
            type: "select",
            label: "L_GAOT_CFRM_OMSN_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        stckCretCtraTpCd: {
            type: "select",
            label: "L_STCK_CRET_CTRA_TP_CD",

            area: "comnCd",
            comnCd: "CGM0095",
        },
        stckClarCtraTpCd: {
            type: "select",
            label: "L_STCK_CLAR_CTRA_TP_CD",
            area: "comnCd",
            comnCd: "CGM0096",
        },
        autoCriYn: {
            type: "select",
            label: "L_AUTO_CRI_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        autoCroYn: {
            type: "select",
            label: "L_AUTO_CRO_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        wrhsDpstDays: { label: "L_WRHS_DPST_DAYS", type: "number" },
        psnWrhsYn: {
            type: "select",
            label: "L_PSN_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        spcdlWrhsYn: {
            type: "select",
            label: "L_SPCDL_WRHS_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        rskCagYn: {
            type: "select",
            label: "L_RSK_CAG_YN",
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        bsopId: {
            type: "file",
            label: "L_ATCH_FILE",
            edit: true,
            bsopClsfCd: "PTL",
            isPublic: true,
        },
        lcneUseTpCd: {
            type: "select",
            label: "L_LCNE_TP_CD",
            area: "comnCd",
            comnCd: "LCM0019",
        },
    },
};

export const SF_CO_DCLT_INFO: TFormSchema = {
    id: "form_coDcltInfo",
    schema: {
        coTin: { type: "text", label: "L_CO_TIN" },
        cfaTin: { type: "text", label: "L_CFA_TIN" },
        dcltTin: { type: "text", label: "L_DCLT_TIN", required: true },
        dcltNm: { type: "text", label: "L_DCLT_NM" },
        dcltAddr: { type: "text", label: "L_DCLT_ADDR" },
        dcltTelno: { type: "text", label: "L_DCLT_TELNO" },
        dcltFaxNo: { type: "text", label: "L_DCLT_FAX_NO" },
        dcltMgmtTin: { type: "text" },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            viewType: "label",
            options: [
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
            ],
            required: true,
        },
    },
};

export const SG_CO_DCLT_LIST: TGridSchema = {
    id: "grid_coDcltList",
    options: { pagination: "in", index: true, height: 200 },
    head: [
        { cells: [{ header: "L_DCLT_TIN", binding: "dcltTin", width: "*" }] },
        { cells: [{ header: "L_DCLT_NM", binding: "dcltNm", width: "*" }] },
        { cells: [{ header: "L_DCLT_ADDR", binding: "dcltAddr", width: "*" }] },
        { cells: [{ header: "L_DCLT_TELNO", binding: "dcltTelno", width: "*" }] },
        { cells: [{ header: "L_DCLT_FAX_NO", binding: "dcltFaxNo", width: "*" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 50 }] },
        { cells: [{ header: "L_ISS_STAT", binding: "lcneStatCd", width: 100 }] },
    ],
    body: [
        { cells: [{ binding: "dcltTin", type: "text", align: "center" }] },
        { cells: [{ binding: "dcltNm", type: "text", align: "left" }] },
        { cells: [{ binding: "dcltAddr", type: "text", align: "left" }] },
        { cells: [{ binding: "dcltTelno", type: "text", align: "left" }] },
        { cells: [{ binding: "dcltFaxNo", type: "text", align: "left" }] },
        {
            cells: [
                {
                    binding: "useYn",
                    type: "select",
                    align: "center",
                    options: [
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                    ],
                    viewType: "label",
                },
            ],
        },
        { cells: [{ binding: "lcneStatCd", type: "code", align: "center", area: "comnCd", comnCd: "LCM0006" }] },
    ],
};

export const SG_CO_EMP_CO_CD_LIST: TGridSchema = {
    id: "grid_coEmpCoCdList",
    options: { index: true, pagination: "in", height: 200 },
    head: [
        { cells: [{ header: "L_CO_TP", binding: "coTpCd", width: 150 }] },
        { cells: [{ header: "L_CO_CD", binding: "coCd", width: 150 }] },
        { cells: [{ header: "L_CO_NM", binding: "coTpNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: 200 }] },
        { cells: [{ header: "L_APPD_YN", binding: "useYn", width: 200 }] },
    ],
    body: [
        { cells: [{ binding: "coTpCd", type: "text", align: "center" }] },
        { cells: [{ binding: "coCd", type: "text", align: "center" }] },
        { cells: [{ binding: "coTpNm", type: "text", align: "left" }] },
        { cells: [{ binding: "cstmOfceCd", type: "text", align: "center" }] },
        {
            cells: [
                {
                    binding: "useYn",
                    type: "radio",
                    align: "center",
                    viewType: "label",
                    options: [
                        { label: "YES", value: "Y" },
                        { label: "NO", value: "N" },
                    ],
                    copy: false,
                },
            ],
        },
    ],
};

// 첨부파일
export const ATCH_FILE_VISIBILITY_MAP = new Map([
    ["AL", new Set(["bsopId"])],
    ["WA", new Set(["bsopId"])],
    ["FF", new Set(["bsopId"])], // Freight Fowarder
    ["SA", new Set(["bsopId"])], // Shipping Agent
    ["SL", new Set(["bsopId"])], // Shipping line
    ["TA", new Set(["bsopId"])], // Terminal Operators
    ["TO", new Set(["bsopId"])], // Terminal Operators (Sea)
]);

// 필드 가시성 메타 정보
export const FIELD_VISIBILITY_MAP = new Map([
    [
        "WA",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
            "spcdlWrhsYn",
        ]),
    ],
    [
        "WB",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WC",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WD",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WE",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WF",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WG",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WH",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WI",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
            "rskCagYn",
        ]),
    ],
    [
        "WK",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WL",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WM",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WP",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WR",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WT",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WV",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WW",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WX",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    [
        "WZ",
        new Set([
            "cstmOfceCd",
            "prcssStatCd",
            "gainCfrmOmsnYn",
            "gaotCfrmOmsnYn",
            "stckCretCtraTpCd",
            "stckClarCtraTpCd",
            "autoCriYn",
            "autoCroYn",
            "wrhsDpstDays",
            "psnWrhsYn",
        ]),
    ],
    // 추가 coTpCd 및 필드 정의
]);

export const CO_CD_LCNE_SET = new Map([
    ["WW", "2"],
    ["WI", "4"],
    ["WB", "8"],
    ["WH", "8"],
    ["WM", "8"],
    ["WF", "9"],
    ["WE", "10"],
    ["WG", "10"],
    ["WP", "10"],
    ["WO", "11"],
    ["CS", "15"],
]);

export const CO_CD_INPUT_TRGT_SET = new Set(["AL", "BK", "FF", "SA", "SL", "VD"]);

export const CO_CD_INPUT_TASAC_SET = new Set(["FF", "SA", "SL"]);

interface InputProperties {
    maxLength: number;
    placeholder: string;
}

export const CO_CD_INPUT_PROPERTIES: { [key: string]: InputProperties } = {
    AL: { maxLength: 2, placeholder: "Enter the 2-char code" },
    BK: { maxLength: 8, placeholder: "Enter the 8-char(4char + 2char + 2char) code" },
    FF: { maxLength: 4, placeholder: "Enter the 4-char code" },
    SA: { maxLength: 3, placeholder: "Enter the 3-char code" },
    SL: { maxLength: 3, placeholder: "Enter the 3-char code" },
    VD: { maxLength: 9, placeholder: "Enter the code" },
};
